import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonHttpOption } from '../../base/common-http-option';
import { CoreService } from '../../base/core';
import { ServiceRoute } from '../../base/service-route';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  constructor(private coreService: CoreService) { }

  catList(filter: any, page: number = 1, pageSize: number = 10): Observable<any> {
  
    return this.coreService.get(
      ServiceRoute.survey.list,
      new CommonHttpOption().headers,
      new CommonHttpOption()
        .paginator(page, pageSize, 'Id', true)
        .append('Id', filter && filter.Id ? filter.Id : '')
        .append('LevelInfoId', filter && filter.LevelInfoId ? filter.LevelInfoId : '')
        .append('PackageId', filter && filter.PackageId ? filter.PackageId : '')
        .append('Title', filter && filter.Title ? filter.Title : '')
        .append('Explain', filter && filter.Explain ? filter.Explain : '')
    );
  }

  questionList(filter: any, page: number = 1, pageSize: number = 10): Observable<any> {
    return this.coreService.get(
      ServiceRoute.survey.questionList,
      new CommonHttpOption().headers,
      new CommonHttpOption()
        .paginator(page, pageSize, 'QuestionTypeId', true)
        .append('Id', filter && filter.Id ? filter.Id : '')
        .append('Title', filter && filter.Title ? filter.Title : '')
        .append('QuestionCatId', filter && filter.QuestionCatId ? filter.QuestionCatId : '')
        .append('QuestionTypeId', filter && filter.QuestionTypeId ? filter.QuestionTypeId : '')
        .append('LevelInfoId', filter && filter.LevelInfoId ? filter.LevelInfoId : '')
        .append('PackageId', filter && filter.LevelInfoId ? filter.PackageId : '')
        .append('IsActive', filter && filter.IsActive ? filter.IsActive : '')
    );
  }

  saveCat(data: any): Observable<any> {
    return this.coreService.post(
      ServiceRoute.survey.surQuestionCatSave,
      data,
      new CommonHttpOption().headers
    );
  }

  surQuestionAdd(data: any): Observable<any> {
    return this.coreService.post(
      ServiceRoute.survey.surQuestionAdd,
      data,
      new CommonHttpOption().headers
    );
  }

  surQuestionEdit(data: any): Observable<any> {
    return this.coreService.put(
      ServiceRoute.survey.surQuestionEdit,
      data,
      new CommonHttpOption().headers
    );
  }

  editCat(data: any): Observable<any> {
    return this.coreService.post(
      ServiceRoute.survey.surQuestionCatEdit,
      data,
      new CommonHttpOption().headers
    );
  }

  surQuestionActiveDeactive(data: any): Observable<any> {
    return this.coreService.put(
      ServiceRoute.survey.surQuestionActiveDeactive,
      data,
      new CommonHttpOption().headers
    );
  }

  delete(data: any): Observable<any> {
    return this.coreService.delete(
      ServiceRoute.survey.surQuestionCatDelete,
      new CommonHttpOption().headers,
      data
    );
  }

  surQuestionDelete(data: any): Observable<any> {
    return this.coreService.delete(
      ServiceRoute.survey.surQuestionDelete,
      new CommonHttpOption().headers,
      data
    );
  }

}
